import { useUserInfoStore } from '@/store/index'
import { goNoAuth } from '@/pages/noAuth/utils/index.js'
export function updateUserInfo() {
  let userStore = useUserInfoStore()
  return userStore.updataUserInfo()
}
export function clearUserInfo() {
  let userStore = useUserInfoStore()
  return userStore.$reset()
}
export function hasUserInfo() {
  let userStore = useUserInfoStore()
  return userStore.userInfo !== null
}
export function goNoAuthPage(key) {
  goNoAuth(key)
}